import { Skeleton } from '@/components/ui/skeleton';
import { useGetSpotlightQuery } from '@/redux/spotlight/spotlight.api.slice';
import { cn } from '@/lib/utils';
import { CreatorCard, DesignCard } from './cards';

function HeroSkeleton() {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      <Skeleton className="h-[340px] w-full rounded-2xl" />
      <Skeleton className="h-[340px] w-full rounded-2xl" />
    </div>
  );
}

/** The opening pair, both picked by an admin: the creator of the month beside
 * the file of the week. Either slot can be empty — a pick can be cleared, or
 * its user blocked — and the section hides when both are. */
// fallow-ignore-next-line complexity
export default function Hero() {
  const { data, isLoading } = useGetSpotlightQuery();
  const { creatorOfTheMonth: creator, fileOfTheWeek: file } = data ?? {};

  const cards = [
    creator ? <CreatorCard key="creator" user={creator} /> : null,
    file ? <DesignCard key="file" file={file} /> : null,
  ].filter(Boolean);

  if (isLoading) return <HeroSkeleton />;
  if (cards.length === 0) return null;

  return (
    <div
      className={cn(
        // auto-rows-fr equalises the side-by-side pair; stacked it just pads
        // the shorter card out to the taller one's height.
        'grid gap-3',
        cards.length > 1 && 'md:auto-rows-fr md:grid-cols-2'
      )}
    >
      {cards}
    </div>
  );
}
